import { ManageRequestComponent } from './manage-request.component';
export var manageRequestRoutes = [
    {
        path: 'manage-request',
        component: ManageRequestComponent,
    }
];
var ManageRequestRoutingModule = (function () {
    function ManageRequestRoutingModule() {
    }
    return ManageRequestRoutingModule;
}());
export { ManageRequestRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/manage-request/manage-request-routing.module.ts.pre-build-optimizer.js